import { Routes, Route, NavLink } from 'react-router-dom';
import { type Me } from '../../lib/api';
import Overview from './Overview';
import RunsPage from './Runs';
import UsersPage from './Users';
import ScenariosPage from './Scenarios';
import AnalyticsPage from './Analytics';
import AuditPage from './Audit';
import CohortsPage from './Cohorts';

export default function InstructorHome({ me }: { me: Me }) {
  const isAdmin = me.role === 'admin' || me.role === 'superadmin';
  return (
    <div className="max-w-7xl mx-auto px-4 py-8">
      <div className="flex gap-6">
        <aside className="w-52 shrink-0">
          <h2 className="text-xs text-mono-white/40 uppercase tracking-widest mb-3">Instructor</h2>
          <nav className="space-y-1 text-sm">
            <Item to="/instructor" end>Overview</Item>
            <Item to="/instructor/runs">Runs</Item>
            <Item to="/instructor/users">Users</Item>
            <Item to="/instructor/scenarios">Scenarios</Item>
            <Item to="/instructor/analytics">Analytics</Item>
            <Item to="/instructor/cohorts">Cohorts</Item>
            {isAdmin && <Item to="/instructor/audit">Audit log</Item>}
          </nav>
          <p className="text-[10px] text-mono-white/30 mt-6 leading-relaxed">
            Signed in as <span className="text-mono-white/60">{me.display_name}</span> · {me.role}
          </p>
        </aside>
        <div className="flex-1 min-w-0">
          <Routes>
            <Route index element={<Overview />} />
            <Route path="runs" element={<RunsPage />} />
            <Route path="users" element={<UsersPage />} />
            <Route path="scenarios" element={<ScenariosPage isAdmin={isAdmin} />} />
            <Route path="analytics" element={<AnalyticsPage />} />
            <Route path="cohorts" element={<CohortsPage />} />
            <Route path="audit" element={<AuditPage />} />
          </Routes>
        </div>
      </div>
    </div>
  );
}

function Item({ to, end, children }: { to: string; end?: boolean; children: React.ReactNode }) {
  return (
    <NavLink to={to} end={end} className={({ isActive }) => `block px-3 py-2 rounded ${isActive ? 'bg-ink-800 text-mono-white' : 'text-mono-white/70 hover:bg-ink-800'}`}>
      {children}
    </NavLink>
  );
}
